import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SelectSchoolProgramComponent } from './select-school-program.component';
import {ExtracurricularService} from "../../services/extracurricular.service";
import {PipeModule} from "../../pipes/pipe.module";



@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgSelectModule,
        FormsModule,
        PipeModule
    ],
  declarations: [SelectSchoolProgramComponent],
  exports: [SelectSchoolProgramComponent],
  providers: [ExtracurricularService]
})
export class SelectSchoolProgramModule {
}
